'use client';

import { useState } from 'react';
import {
  FaFacebookSquare,
  FaPinterestSquare,
  FaTwitterSquare,
} from 'react-icons/fa';
import {
  FaFacebook,
  FaLink,
  FaLinkedin,
  FaRegEnvelope,
  FaXTwitter,
} from 'react-icons/fa6';
import {
  EmailShareButton,
  FacebookShareButton,
  // FacebookIcon,
  LinkedinShareButton,
  PinterestShareButton,
  // PinterestIcon,
  TwitterShareButton,
  // TwitterIcon,
} from 'react-share';
import './socialShare.scss';

interface SocialShareProps {
  url: string;
  title?: string;
  media?: string;
  description?: string;
  showPinterest?: boolean;
  /** 'post' is the blog/resources article row: email, copy link, Facebook, X, LinkedIn. */
  variant?: 'default' | 'post';
}

const SocialShare = ({
  url,
  media,
  description,
  title,
  showPinterest = true,
  variant = 'default',
}: SocialShareProps) => {
  const [copied, setCopied] = useState(false);
  // const facebookBgStyle = { fill: '#cad808' }; // Facebook blue
  // const twitterBgStyle = { fill: '#cad808' }; // Twitter blue
  // const pinterestBgStyle = { fill: '#cad808' }; // Pinterest red

  if (variant === 'post') {
    const copyLink = async () => {
      try {
        await navigator.clipboard.writeText(url);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      } catch {
        // Clipboard can be blocked (insecure context, permissions) - nothing to fall back to.
      }
    };

    return (
      <div className="social-share social-share--post">
        <EmailShareButton url={url} subject={title} aria-label="Share by email">
          <FaRegEnvelope aria-hidden="true" />
        </EmailShareButton>
        <button
          type="button"
          className="social-share__copy"
          onClick={copyLink}
          aria-label={copied ? 'Link copied' : 'Copy link'}
          title={copied ? 'Link copied' : 'Copy link'}
        >
          <FaLink aria-hidden="true" />
        </button>
        <FacebookShareButton url={url} aria-label="Share on Facebook">
          <FaFacebook aria-hidden="true" />
        </FacebookShareButton>
        <TwitterShareButton url={url} title={title} aria-label="Share on X">
          <FaXTwitter aria-hidden="true" />
        </TwitterShareButton>
        <LinkedinShareButton url={url} aria-label="Share on LinkedIn">
          <FaLinkedin aria-hidden="true" />
        </LinkedinShareButton>
        <span className="visually-hidden" aria-live="polite">
          {copied ? 'Link copied' : ''}
        </span>
      </div>
    );
  }

  return (
    <>
      <TwitterShareButton url={url} title={title} aria-label="Share on Twitter">
        <FaTwitterSquare size={32} aria-hidden="true" />
        {/* <TwitterIcon size={32} bgStyle={twitterBgStyle} /> */}
      </TwitterShareButton>
      <FacebookShareButton url={url} aria-label="Share on Facebook">
        {/* <FacebookIcon size={32} bgStyle={facebookBgStyle} /> */}
        <FaFacebookSquare size={32} aria-hidden="true" />
      </FacebookShareButton>
      {showPinterest && (
        <PinterestShareButton
          url={url}
          media={media ? media : ''}
          description={description ? description : ''}
          aria-label="Share on Pinterest"
        >
          <FaPinterestSquare size={32} aria-hidden="true" />
          {/* <PinterestIcon size={32} bgStyle={pinterestBgStyle} /> */}
        </PinterestShareButton>
      )}
    </>
  );
};

export default SocialShare;
